import convertAddressesToLinks from './convertAddressesToLinks';
import mailTipsOOFTruncate from './mailTipsOOFTruncate';
/**
 * @param textContent is the text content of the OOF message (with all HTML/ JS/ Styling removed)
 * returns long and truncated oof message for oof infobar
 * @param shouldTruncateOOFMessage when true it returns truncated OOF Message
 */
const getOOFMessage = (textContent: string, shouldTruncateOOFMessage?: boolean): JSX.Element => {
    if (shouldTruncateOOFMessage) {
        const nonLinkifiedMailtipsTruncated = mailTipsOOFTruncate(textContent);
        return convertAddressesToLinks(nonLinkifiedMailtipsTruncated);
    }

    return convertAddressesToLinks(textContent);
};

export default getOOFMessage;
